// extracted by mini-css-extract-plugin
module.exports = {"TopMenuItems":"TopMenuItems_TopMenuItems__1mkPB","Back":"TopMenuItems_Back__2t85h"};